import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_producto_servicio = {
      ...state.app.catalogos.cartaporte_producto_servicio,
      filters: {
        ...state.app.catalogos.cartaporte_producto_servicio.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.cartaporte_producto_servicio;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/cartaporte-productos-servicios', { params });

    store.setState((state) => {
      state.app.catalogos.cartaporte_producto_servicio = {
        ...state.app.catalogos.cartaporte_producto_servicio,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.cartaporte_producto_servicio.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.cartaporte_producto_servicio.busy = false;
      state.app.catalogos.cartaporte_producto_servicio.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_producto_servicio = {
      ...initialState,
    };
  });
};

const CartaPorteProductoServicioSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default CartaPorteProductoServicioSuggestionsStore;
